// extracted by mini-css-extract-plugin
export default {"productCategoryCardSet":"ProductCategoryCardSet_productCategoryCardSet__dUV1+"};